import * as React from 'react';
import './BarrGraphic.scss'

import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper, LinearProgress, Typography
} from '@material-ui/core';
import { IBarrGraphicProps, IBarrGraphicState,  IBarrGraphicDataChart } from './BarrGraphic';
import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Bar, LabelList } from 'recharts';

const dataFilled = (data: any) => {
    return data && data.rows && !!data.rows.length
}

const BarrGraphicDataChart = ({ data }: { data: IBarrGraphicDataChart[] }) => (

    <div>
        <ResponsiveContainer width="100%" height={600} >
            <BarChart
                    data={data}
                    margin={{ top: 5, right: 20, left: 100, bottom: 5 }}
                    layout="vertical">
                    <CartesianGrid vertical={false} horizontal={false} />
                    <XAxis type="number" hide={true}/>
                    <YAxis yAxisId="center" type="category" dataKey="dimension"  tick={{fontSize: '65%'}}/>
                    <Bar yAxisId="center" dataKey="metric" fill="#46a3d0" barSize={25} isAnimationActive={false} >
                        <LabelList dataKey="metric" position="right" className="recharts-label-custom-black" />
                    </Bar>
                </BarChart>
        </ResponsiveContainer>
    </div>
);

export class BarrGraphicModal extends React.Component<IBarrGraphicProps, IBarrGraphicState> {
    constructor(props: IBarrGraphicProps) {
        super(props);
        this.state = {
          dialogOpen: false,
        }
    }

    public render() : any {
        const data = this.props.dataProp;

        return (
            <div className="filter-item">
                <Button onClick={this.handleDialogOpen} color="primary">
                    Ver Mais
                </Button>
                <Dialog
                    fullScreen={true}
                    open={this.state.dialogOpen}
                    onClose={this.handleDialogClose}
                    aria-labelledby="economic-group-dialog-title"
                    aria-describedby="alereconomic-group-dialog-description"
                    className="filter-dialog"
                >
                    <DialogTitle className="filter-dialog-title" id="economic-group-dialog-title">{this.props.title}</DialogTitle>
                    <DialogContent className="filter-dialog-content">
                        <Paper className="publisher-sale-block panel-block" >
                            {
                                this.props.loading ? 
                                <LinearProgress /> : 
                                dataFilled(data) ?
                                    (<BarrGraphicDataChart data={this.BarrGraphicDataChartMap(data.rows)} />) :
                                    (
                                        <Typography variant="body2" className="comparative" component="p">
                                            Não há informações de vendas
                                        </Typography>
                                    )
                            }
                        </Paper>
                    </DialogContent>
                    <DialogActions className="filter-actions">
                        <Button className="filter-dialog-close" onClick={this.handleDialogClose} >
                            Fechar
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }

    private BarrGraphicDataChartMap = (data: any[]) => {

        const mappedData: IBarrGraphicDataChart[] = [];

        data.forEach(e => {

            const item: IBarrGraphicDataChart = {
                dimension: e.dimensions[this.props.dimensionIndex],
                metric: Number(e.metrics[0].values[this.props.metricsIndex]),
            };

            mappedData.push(item);

        });

        return mappedData;
    }

    private handleDialogOpen = () => {
        this.setState({ dialogOpen: true });
    };

    private handleDialogClose = () => {
        this.setState({ dialogOpen: false });
    };

}



// WEBPACK FOOTER //
// ./src/component/administration/analytics/shared/graphics/barrGraphic/BarrGraphicModal.tsx